import { Modal } from '@bbl-digital/snorre'
import { FC } from 'react'
import SkeletonInput from 'shared/components/skeletons/SkeletonInput'
import { SkeletonWrapper } from './styles'

interface IProps {
  onClose: () => void
}

const SendEmailLoading: FC<IProps> = ({ onClose }) => {
  return (
    <Modal open disableScroll={false} width="1100px" onClose={onClose}>
      <SkeletonWrapper>
        <SkeletonInput />
        <SkeletonInput />
        <SkeletonInput hideLabel inputHeight="400px" />
      </SkeletonWrapper>
    </Modal>
  )
}

export default SendEmailLoading
